import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import ResponsivePanel from 'PreviewComponents/SideBar/Panels/Containers/ResponsivePanel';
import PagePanel from 'PreviewComponents/SideBar/Panels/Containers/PagePanel';
import CustomPanel from 'PreviewComponents/SideBar/Panels/Containers/CustomPanel';
import ContainerSelector from 'PreviewComponents/SideBar/ContainerSelector/ContainerSelector';
import { colourWhite, colourMasterLight } from 'Styles/colors.css';
import { UI } from 'SharedConstants/';
import { SELECTED_CONTAINER, SETTINGS_PANEL_WIDTH } from 'PreviewConstants/';

const Container = styled.div`
    position: fixed;
    margin-bottom: 0;
    z-index: 500;
    border-left: 1px solid ${colourMasterLight};
    width: ${SETTINGS_PANEL_WIDTH}px;
    right: -${SETTINGS_PANEL_WIDTH}px;
    bottom: 0px;
    top: 0px;
    background-color: ${colourWhite}
`;

const PanelContents = styled.div`
  position: relative;
`;

class SettingsPanel extends Component {
  render() {
    const { selectedContainer } = this.props;
    const { toggleSideBar } = this;

    return (
      <PanelContents>
        <div style={{ overflow: 'visible' }} >
          <ContainerSelector />

          {(selectedContainer === 'responsive') && <ResponsivePanel />}
          {(selectedContainer === 'page') && <PagePanel />}
          {(selectedContainer === 'custom') && <CustomPanel />}

        </div>
      </PanelContents>);
  }
}

// export default SideBar;

SettingsPanel.propTypes = {
  selectedContainer: PropTypes.string,
};

SettingsPanel.defaultProps = {
  selectedContainer: 'standard',
};

const mapStateToProps = state => ({
  selectedContainer: state.getIn([UI, SELECTED_CONTAINER]),
});

export default connect(mapStateToProps, null)(SettingsPanel);



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/SideBar/Panels/SettingsPanel.jsx